module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes_2019--6-6071ad5e.png";